var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-your-diagnostic-template',{attrs:{"language":_vm.locale,"language-options":_vm.languageOptions,"doctor-info":_vm.doctorInfo,"user-info":_vm.patientInfo},on:{"start-questionnaire":_vm.onStartQuiz,"start-photo-analysis":_vm.onStartPhotoAnalysis,"change-language":_vm.onChangeLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }